import { render, staticRenderFns } from "./editMessage.vue?vue&type=template&id=76a3897c"
import script from "./editMessage.vue?vue&type=script&lang=js"
export * from "./editMessage.vue?vue&type=script&lang=js"
import style0 from "./editMessage.vue?vue&type=style&index=0&id=76a3897c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports